import { MenuItem, MenuList, Stack, Typography as MuiTypography, useTheme } from "@mui/material";
import { Button, Typography } from "@foodpilot/foods";
import type { ActionsPopoverAppearance } from "./ActionsPopover";
import { MenuItemType } from "./ActionsPopover.types";

type RowMenuProps = {
    menuItems: MenuItemType<unknown>[];
    appearance: ActionsPopoverAppearance;
};

const RowMenu = ({ menuItems, appearance }: Readonly<RowMenuProps>) => {
    const theme = useTheme();

    if (appearance === "legacy") {
        return (
            <MenuList
                autoFocusItem
                disablePadding
                sx={{ display: "flex", flexDirection: "column", gap: theme.spacing(2.5) }}
            >
                {menuItems.map((item, index) => (
                    <MenuItem
                        key={`popover-${index}`}
                        onClick={item.onClick}
                        sx={{ padding: theme.spacing(0.75) }}
                        disabled={Boolean(item.isDisabled)}
                    >
                        {item.icon}
                        <MuiTypography sx={theme.custom.rowMenuElement}>{item.label}</MuiTypography>
                    </MenuItem>
                ))}
            </MenuList>
        );
    }

    return (
        <Stack direction="column" gap={theme.spacing(2.5)} useFlexGap>
            {menuItems.map((item, index) => (
                <Button
                    key={`popover-${index}`}
                    role="menuitem"
                    variant="black-text"
                    onClick={item.onClick}
                    startIcon={item.icon}
                    disabled={Boolean(item.isDisabled)}
                    sx={{
                        justifyContent: "flex-start",
                        padding: theme.spacing(0.75),
                        width: "100%",
                        "&:hover, &.Mui-focusVisible": { background: theme.palette.action.hover },
                    }}
                >
                    <Typography sx={theme.custom.rowMenuElement}>{item.label}</Typography>
                </Button>
            ))}
        </Stack>
    );
};

export default RowMenu;
